














import Vue from 'vue'
import BaseButton from '../atoms/BaseButton.vue'

export default Vue.extend({
  components: {
    BaseButton
  },
  props: {
    contents: {
      type: Object,
      required: true
    }
  },
  computed: {
    releasedContents() {
      return Object.entries(this.contents)
    }
  },
  methods: {
    moveMonth(month: string) {
      this.$store.commit('SET_MONTH', { month: parseInt(month.slice(4)) })
      this.$store.commit('SET_YEAR', { year: parseInt(month.slice(0, 4)) })
    }
  }
})
